<script>
import {getInviteVisitorFormSetting, getVisitorConfigSetting, setSystemSettingInfo} from "@/api/setting-api";

export default {
  name: "VisitorInfoPage",
  data() {
    return {
      activeName: "first",
      applyActiveName: "first",
      inviteActiveName: "first",

      form1: {
        idType: "",
        IDDepends: "",
        PASSPORTDepends: "",
        idCardNo: 2, // 身份证号设置  1不展示， 2选填， 3必填; 默认选填
        nationality: 1, // 国籍设置  1不展示， 2选填， 3必填； 默认不展示
        passport: 1, // 护照设置  1不展示， 2选填， 3必填； 默认不展示

      },
      rules: {
        idType: [
          {required: true, message: '请选择证件类型', trigger: 'change'},
        ],
        idCardNo: [
          {required: true, message: '请选择身份证号设置', trigger: 'change'},
        ],
        nationality: [
          {required: true, message: '请选择国籍设置', trigger: 'change'},
        ],
        passport: [
          {required: true, message: '请选择护照设置', trigger: 'change'},
        ],
      },

      form2: {
        idType: "",
        IDDepends: "",
        PASSPORTDepends: "",

        idCardNo: 2, // 身份证号设置  1不展示， 2选填， 3必填; 默认选填
        nationality: 1, // 国籍设置  1不展示， 2选填， 3必填； 默认不展示
        passport: 1, // 护照设置  1不展示， 2选填， 3必填； 默认不展示

      },
    }
  },// end of data

  mounted() {

    this.requiredForm1()
  },

  methods: {

    requiredForm1() {
      getVisitorConfigSetting().then(({data}) => {
        console.log("getVisitorConfigSetting", data)
        if (data.code === 200) {
          data.data.forEach(item => {
            if (item.type === "VISITOR_BOOK") {
              let content = JSON.parse(item.content)
              if (content) {
                this.form1.idCardNo = content.idCardNo
                this.form1.nationality = content.nationality
                this.form1.passport = content.passport
                this.form1.idType = content.value
                content.depends.forEach(dep => {
                  if (dep.name === "ID") {
                    this.form1.IDDepends = dep.dependField
                  } else if (dep.name === "PASSPORT") {
                    this.form1.PASSPORTDepends = dep.dependField
                  }
                })
              }
            }
          })

        } else {
          this.showServerErrMsg(data)
        }
      }).catch((err) => {
        this.showNetErrMsg(err)
      })

    },
    requiredForm2() {
      getInviteVisitorFormSetting().then(({data}) => {
        console.log("getInviteVisitorFormSetting", data)
        if (data.code === 200) {
          data.data.forEach(item => {
            if (item.type === "VISITOR_INVITE") {
              let content = JSON.parse(item.content)
              if (content) {
                this.form2.idCardNo = content.idCardNo
                this.form2.nationality = content.nationality
                this.form2.passport = content.passport
                this.form2.idType = content.value
                content.depends.forEach(dep => {
                  if (dep.name === "ID") {
                    this.form2.IDDepends = dep.dependField
                  } else if (dep.name === "PASSPORT") {
                    this.form2.PASSPORTDepends = dep.dependField
                  }
                })
              }
            }
          })
        }
      }).catch((err) => {
        this.showNetErrMsg(err)
      })
    },


    onSubmitForm1() {
      this.$refs.form1.validate((valid) => {
        if (valid) {
          const postData = {
            "target": "VISITORINFO", "type": "VISITOR_BOOK", "content": JSON.stringify({
              value: this.form1.idType,
              depends: [
                {name: "ID", dependField: this.form1.IDDepends},
                {name: "PASSPORT", dependField: this.form1.PASSPORTDepends}
              ],
              idCardNo: this.form1.idCardNo,
              nationality: this.form1.nationality,
              passport: this.form1.passport
            }), "state": "VALID"
          }
          setSystemSettingInfo(postData).then(({data}) => {
            if (data.code === 200) {
              this.$message.success("保存成功")
            } else {
              this.showServerErrMsg(data)
            }
          }).catch((err) => {
            this.showNetErrMsg(err)
          })
        }
      });
    },
    onSubmitForm2() {
      this.$refs.form2.validate((valid) => {
        if (valid) {
          const postData = {
            "target": "VISITORINFO", "type": "VISITOR_INVITE", "content": JSON.stringify({
                  value: this.form2.idType,
                  depends: [
                    {name: "ID", dependField: this.form2.IDDepends},
                    {name: "PASSPORT", dependField: this.form2.PASSPORTDepends}
                  ],
                  idCardNo: this.form2.idCardNo,
                  nationality: this.form2.nationality,
                  passport: this.form2.passport
                }
            ), "state": "VALID"
          }
          setSystemSettingInfo(postData).then(({data}) => {
            if (data.code === 200) {
              this.$message.success("保存成功")
            } else {
              this.showServerErrMsg(data)
            }
          }).catch((err) => {
            this.showNetErrMsg(err)
          })
        }
      })
    },

    onTabChange() {
      if (this.activeName === "first") {
        this.requiredForm1()
      } else if (this.activeName === "second") {
        this.requiredForm2()
      }
    },
  }
}
</script>

<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="onTabChange">

      <el-tab-pane label="预约设置" name="first">
        <h4>证件类型</h4>
        <el-form ref="form1" :rules="rules" :model="form1" label-width="100px" label-position="left">
          <el-form-item label="证件类型">
            <el-radio v-model="form1.idType" label="NONE" border size="small">无要求</el-radio>
            <el-radio v-model="form1.idType" label="ID" border size="small">身份证</el-radio>
            <el-radio v-model="form1.idType" label="PASSPORT" border size="small">护照</el-radio>
            <el-radio v-model="form1.idType" label="ALL" border size="small">二选一</el-radio>

          </el-form-item>
          <el-form-item label="身份证依赖" v-if="form1.idType === 'ID' ||  form1.idType === 'ALL'">
            <el-radio v-model="form1.IDDepends" label="">无要求</el-radio>
            <el-radio v-model="form1.IDDepends" label="email">邮箱</el-radio>
          </el-form-item>
          <el-form-item label="护照依赖" v-if="form1.idType === 'PASSPORT' ||  form1.idType === 'ALL'">
            <el-radio v-model="form1.PASSPORTDepends" label="">无要求</el-radio>
            <el-radio v-model="form1.PASSPORTDepends" label="email">邮箱</el-radio>
          </el-form-item>
        </el-form>
        <h4>字段设置</h4>
        <el-form ref="form2" :rules="rules" :model="form1" label-width="100px" label-position="left">
          <el-form-item label="身份证" prop="idCardNo">
            <el-radio-group v-model="form1.idCardNo">
              <el-radio border :label="1">不展示</el-radio>
              <el-radio border :label="2">选填</el-radio>
              <el-radio border :label="3">必填</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="国籍" prop="nationality">
            <el-radio-group v-model="form1.nationality">
              <el-radio border :label="1">不展示</el-radio>
              <el-radio border :label="2">选填</el-radio>
              <el-radio border :label="3">必填</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="护照" prop="passport">
            <el-radio-group v-model="form1.passport">
              <el-radio border :label="1">不展示</el-radio>
              <el-radio border :label="2">选填</el-radio>
              <el-radio border :label="3">必填</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmitForm1">保存</el-button>
          </el-form-item>
        </el-form>

      </el-tab-pane>

      <el-tab-pane label="邀约设置" name="second">
        <h4>证件类型</h4>
        <el-form ref="form2" :rules="rules" :model="form2" label-width="100px" label-position="left">
          <el-form-item label="证件类型">
            <el-radio v-model="form2.idType" label="NONE" border size="small">无要求</el-radio>
            <el-radio v-model="form2.idType" label="ID" border size="small">身份证</el-radio>
            <el-radio v-model="form2.idType" label="PASSPORT" border size="small">护照</el-radio>
            <el-radio v-model="form2.idType" label="ALL" border size="small">二选一</el-radio>

          </el-form-item>
          <el-form-item label="身份证依赖" v-if="form2.idType === 'ID' ||  form2.idType === 'ALL'">
            <el-radio v-model="form2.IDDepends" label="">无要求</el-radio>
            <el-radio v-model="form2.IDDepends" label="email">邮箱</el-radio>
          </el-form-item>
          <el-form-item label="护照依赖" v-if="form2.idType === 'PASSPORT' ||  form2.idType === 'ALL'">
            <el-radio v-model="form2.PASSPORTDepends" label="">无要求</el-radio>
            <el-radio v-model="form2.PASSPORTDepends" label="email">邮箱</el-radio>
          </el-form-item>
        </el-form>
        <h4>字段设置</h4>
        <el-form ref="form2" :rules="rules" :model="form2" label-width="100px" label-position="left">
          <el-form-item label="身份证" prop="idCardNo">
            <el-radio-group v-model="form2.idCardNo">
              <el-radio border :label="1">不展示</el-radio>
              <el-radio border :label="2">选填</el-radio>
              <el-radio border :label="3">必填</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="国籍" prop="nationality">
            <el-radio-group v-model="form2.nationality">
              <el-radio border :label="1">不展示</el-radio>
              <el-radio border :label="2">选填</el-radio>
              <el-radio border :label="3">必填</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="护照" prop="passport">
            <el-radio-group v-model="form2.passport">
              <el-radio border :label="1">不展示</el-radio>
              <el-radio border :label="2">选填</el-radio>
              <el-radio border :label="3">必填</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmitForm2">保存</el-button>
          </el-form-item>
        </el-form>

      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<style scoped lang="less">

.nav-item {
  margin-right: 15px;
}

/deep/ .el-radio-button__inner {
  background-color: #efefef;
}

::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 60px;

}

::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 60px;
}
</style>
